import { Identifier, randomUUID } from "../id";
export class PModifierItemInstanceId extends Identifier {
    constructor() {
        super("PModifierItemInstanceId", randomUUID());
    }
}
